import * as React from 'react';
import SvgImage from '../SvgImage';
import './styles.scss';

interface SearchFieldProps {
  name?: string;
  label: string;
  placeholder?: string;
  callback?: Function;
  value: string;
  onSearchClear?: React.MouseEventHandler<HTMLButtonElement>;
}

const SearchField = ({
  name = 'search',
  label,
  placeholder = 'search',
  callback,
  value,
  onSearchClear,
}: SearchFieldProps) => (
  <div className="search-field">
    <input
      className="search-field__input"
      type="text"
      name={name}
      placeholder={placeholder}
      value={value}
      onChange={(event) => callback && callback(event.currentTarget.value)}
    />
    <label htmlFor={name}>
      {label}
    </label>

    {value && onSearchClear ? (
      <button onClick={onSearchClear} className="search-field__clear-trigger">
        <SvgImage reference="#icon-close" title="clear search input" />
      </button>
    ) : (
      <div className="search-field__icon">
        <SvgImage reference="#icon-search" title="search" />
      </div>
    )}
  </div>
);

export default SearchField;
